import MessageHeader from "./MessageHeader";
import MessageBody from "./MessageBody";
import MessageFooter from "./MessageFooter";
import { useState, useRef, useEffect } from "react";
import { IMAGE_MIME_TYPES } from "../../../utils/constants";
import {
  IoDocumentTextOutline,
  IoAddSharp,
  IoCloseOutline,
} from "react-icons/io5";

const Messages = ({ room, messages, setMessages, setOpen }) => {
  const [files, setFiles] = useState([]);

  const fileRef = useRef(null);

  const handleClick = () => fileRef.current.click();

  const handleDelete = (index) => {
    const data = [...files];
    const updated = data
      .slice(0, index)
      .concat(data.slice(index + 1, data.length));

    setFiles(updated);
  };

  useEffect(() => {
    setFiles([]);
  }, [room]);

  return (
    <div className="flex flex-col w-full h-full">
      <MessageHeader room={room} setOpen={setOpen} />
      <MessageBody room={room} messages={messages} setMessages={setMessages} />
      {files.length > 0 && (
        <div className="py-5 px-8 border-t border-gray-100 dark:border-gray-700">
          <div className="flex space-x-2">
            {files.map((item, index) => {
              const isImage = IMAGE_MIME_TYPES.includes(item.type);

              return (
                <div className="relative group" key={index}>
                  <div
                    onClick={() => handleDelete(index)}
                    className="absolute inset-0 bg-gray-50 cursor-pointer z-50 opacity-0 group-hover:opacity-50 w-24 h-24 rounded-lg flex justify-center items-center"
                  >
                    <IoCloseOutline className="text-red-500 text-2xl opacity-100" />
                  </div>
                  <div className="relative">
                    {!isImage && (
                      <div className="flex items-center justify-center w-24 h-24 rounded-lg border border-gray-300 dark:border-gray-500">
                        <div className="w-full">
                          <IoDocumentTextOutline className="text-4xl mx-auto text-gray-400" />
                          <p className="text-xs truncate mx-auto w-14 text-gray-400 mt-3">
                            {item.name}
                          </p>
                        </div>
                      </div>
                    )}
                    {isImage && (
                      <img
                        alt={item.name}
                        src={URL.createObjectURL(item)}
                        className="w-24 h-24 rounded-lg"
                      />
                    )}
                  </div>
                </div>
              );
            })}
            {files.length < 3 && (
              <div
                onClick={() => handleClick()}
                className="flex cursor-pointer items-center justify-center h-24 w-24 rounded-lg border border-dashed border-blue-500"
              >
                <IoAddSharp className="text-2xl text-blue-400" />
              </div>
            )}
          </div>
        </div>
      )}
      <MessageFooter
        room={room}
        fileRef={fileRef}
        files={files}
        setFiles={setFiles}
        onClick={handleClick}
      />
    </div>
  );
};

export default Messages;
